import React, { ReactNode } from "react";
import { Grid } from "semantic-ui-react";
import useWindowDimensions from "../../hooks/windowsSize";

import { CustomButton } from "../button/Button";
import "./mainBottomButton.scss";

interface MainBottomButtonViewProps {
  customHeight?: number | null;
  deleteStatus?: boolean;
  cancelButtonStatus?: boolean;
  saveButtonStatus?: boolean;
  deleteButton?: () => void;
  saveButton?: () => void;
  cancelButton?: () => void;
  bounceEnable?: boolean;
  cancelButtonTitle?: string;
  saveTitle?: string;
  type?: "button" | "submit" | "reset";
  saveDisable?: boolean;
  deleteDisable?: boolean;
  cancelDisable?: boolean;
  isSimulation?: boolean;
  customBottomContentMain?: any;
  testId?: string;
  deleteButtonTheme?: "green" | "red";
  deleteButtonGhost?: boolean;
  deleteButtonIcon?: ReactNode;
}

const MainBottomButtonView: React.FC<MainBottomButtonViewProps> = ({
  customHeight = null,
  deleteStatus = false,
  cancelButtonStatus = false,
  saveButtonStatus = false,
  deleteButton = () => {},
  saveButton = () => {},
  cancelButton = () => {},
  bounceEnable = false,
  saveTitle = "Save",
  type = "button",
  saveDisable = false,
  cancelDisable = false,
  deleteDisable = false,
  isSimulation = false,
  cancelButtonTitle = "Cancel",
  customBottomContentMain,
  testId = "main-bottom-button-view",
  deleteButtonTheme = "green",
  deleteButtonGhost = false,
  deleteButtonIcon
}) => {
  const { height } = useWindowDimensions();
  const heightView = customHeight || height * 0.1;

  return (
    <Grid
      style={{ height: heightView }}
      className={`p-1 bottomButtonContent ${customBottomContentMain}`}
    >
      <Grid.Column computer={9} tablet={16} mobile={16}>
        <Grid>
          {cancelButtonStatus && (
            <Grid.Column computer={4} tablet={16} mobile={16} className="pb-0">
              <CustomButton
                theme="green"
                title={cancelButtonTitle}
                onClick={() => {
                  cancelButton();
                }}
                buttonOutLine={true}
                disabled={cancelDisable}
              />
            </Grid.Column>
          )}
          {deleteStatus && (
            <Grid.Column computer={4} tablet={16} mobile={16} className="pb-0">
              <CustomButton
                theme={deleteButtonTheme}
                title={"Delete"}
                onClick={() => {
                  deleteButton();
                }}
                buttonOutLine={!deleteButtonGhost}
                ghost={deleteButtonGhost}
                iconWithText={!!deleteButtonIcon}
                iconChild={deleteButtonIcon}
                iconChildTextCustom={deleteButtonGhost ? "!tw-text-destructive" : undefined}
                disabled={deleteDisable}
                data-testid={`${testId}-delete-button`}
              />
            </Grid.Column>
          )}
        </Grid>
      </Grid.Column>
      <Grid.Column computer={7} tablet={16} mobile={16} textAlign="right" className="pb-0">
        {saveButtonStatus && !isSimulation && (
          <CustomButton
            theme="green"
            title={saveTitle}
            onClick={() => saveButton()}
            type={type}
            disabled={saveDisable}
            className={bounceEnable ? "bounce-effect" : ""}
            data-testid={`${testId}-save-button`}
          />
        )}
      </Grid.Column>
    </Grid>
  );
};

export default MainBottomButtonView;
